module.exports = __webpack_public_path__ + "img/pickup-pin.df974049.svg";